import { render, staticRenderFns } from "./calock.vue?vue&type=template&id=5650980e&scoped=true"
import script from "./calock.vue?vue&type=script&lang=js"
export * from "./calock.vue?vue&type=script&lang=js"
import style0 from "./calock.vue?vue&type=style&index=0&id=5650980e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5650980e",
  null
  
)

export default component.exports